import React from 'react'

const TripLoading = () => {
  return (
       <div className="min-h-screen flex flex-col items-center justify-center font-instrument text-center">
                <img
                    src="/logo1.svg"
                    alt="Logo"
                    className="w-[160px] mb-6"
                    style={{
                        animation: "float 2s ease-in-out infinite"
                    }}
                />
                <style>
                    {`
                @keyframes float {
                    0% { transform: translateY(0px) scale(1); opacity: 0.9; }
                    50% { transform: translateY(-10px) scale(1.05); opacity: 1; }
                    100% { transform: translateY(0px) scale(1); opacity: 0.9; }
                }
                `}
                </style>

            </div>
  )
}

export default TripLoading